import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";

const PUBLIC = process.env.PUBLIC_URL || "";

export const HERO_SLIDES = [
  `${PUBLIC}/New/slider1.jpeg`,
  `${PUBLIC}/New/slider2.jpeg`,
  `${PUBLIC}/New/slider3.jpeg`,
  `${PUBLIC}/New/slider4.jpeg`,
  `${PUBLIC}/New/slider5.jpeg`,
  `${PUBLIC}/New/slider6.jpeg`,
];

const ROTATE_MS = 6000;

/** onActiveChange(index) lets the header overlay an offer card while an offer slide shows. */
export default function HomeHeroSlider({ slideUrls, onActiveChange }) {
  const slides = slideUrls?.length ? slideUrls : HERO_SLIDES;
  const [activeIndex, setActiveIndex] = useState(0);
  const [loadedSlides, setLoadedSlides] = useState(() => new Set([0]));

  useEffect(() => {
    setActiveIndex(0);
    setLoadedSlides(new Set([0]));
  }, [slides.join('|')]);

  useEffect(() => {
    onActiveChange?.(activeIndex);
  }, [activeIndex, onActiveChange]);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const timer = window.setInterval(() => {
      setActiveIndex((prev) => {
        const next = (prev + 1) % slides.length;
        setLoadedSlides((loaded) => {
          if (loaded.has(next)) return loaded;
          const updated = new Set(loaded);
          updated.add(next);
          return updated;
        });
        return next;
      });
    }, ROTATE_MS);
    return () => window.clearInterval(timer);
  }, [slides.length]);

  return (
    <Box className="home-hero-slider" aria-hidden="true">
      {slides.map((src, index) => {
        if (!loadedSlides.has(index)) return null;
        const isActive = index === activeIndex;
        const isLcp = index === 0;

        return (
          <Box
            key={src}
            className={isActive ? "home-hero-slide home-hero-slide--active" : "home-hero-slide"}
            sx={{
              position: "absolute",
              inset: 0,
              opacity: isActive ? 1 : 0,
              transition: "opacity 1.2s ease-in-out",
              pointerEvents: "none",
              overflow: "hidden",
            }}
          >
            <img
              src={src}
              alt=""
              className="home-hero-slide-img"
              width={1920}
              height={1080}
              loading={isLcp ? "eager" : "lazy"}
              fetchPriority={isLcp ? "high" : undefined}
              decoding="async"
              sizes="100vw"
            />
          </Box>
        );
      })}
    </Box>
  );
}
